import { ƒ_about, ƒ_home, ƒ_linkInBio, ƒ_photograph, ƒ_photographs, ƒ_thought, ƒ_thoughts } from '$lib/routes';

const routes = {
	[ƒ_home.id]: '/[locale]',
	[ƒ_about.id]: '/[locale]/about-me',
	[ƒ_linkInBio.id]: '/[locale]/link-in-bio',
	[ƒ_thoughts.id]: '/[locale]/thoughts',
	[ƒ_thought.id]: '/[locale]/thoughts/[year]/[month]/[day]/[slug]',
	[ƒ_photographs.id]: '/[locale]/photographs',
	[ƒ_photograph.id]: '/[locale]/photographs/[year]/[month]/[day]/[slug]'
};

export default routes;
